import { useEffect, useState } from "react";
import { Column, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { C1Text, C3Text } from "../../../common/components/text/CustomText";
import { CustomTable, ShopStatus } from "../../../common/components/table/CustomTable";
import Translate from "../../../common/translate/Translate";
import CustomNetworkImage from "../../../common/components/image/CustomNetworkImage";
import UIUtil from "../../../common/utils/UIUtil";
import CustomIcon from "../../../common/components/image/CustomIcon";
import { useNavigate } from "react-router-dom";
import { Theme } from "../../../common/Theme";
import DashboardService from "../../../service/DashboardService";
import { format } from "date-fns";

function TopTenUsageDashboardCard() {
    const navigation = useNavigate();
    const service = new DashboardService();
    const [shopList, setShopList] = useState([]);

    const fetchTopTenShops = () => {
        const today = format(new Date(), "yyyy-MM-dd");
        service
            .getTopTenShops({ today })
            .then((result) => {
                const mapped = result.map((item, index) => ({
                    rank: item.ranking,
                    shopCode: item.shopCode ?? "",
                    shopName: item.storeName,
                    thumbnail: item.imgeUrl,
                    address: item.address ?? "",
                    ownerName: item.contact,
                    status: item.status ?? "",
                    totalCycle: item.totalCycle,
                }));
                setShopList(mapped);
            })
            .catch((error) => {
                console.error("Error fetching top ten shops:", error);
            });
    };

    useEffect(() => {
        fetchTopTenShops();
    }, []);

    const tableHeaders = [
        {
            key: "rank",
            label: "Rank",
            render: (row) => {
                if (row.rank <= 3) {
                    const { icon } = UIUtil.getRankIcon(row.rank);
                    return <CustomIcon iconName={icon} size={"26px"} />;
                } else {
                    return (
                        <C3Text fontColor={Theme.color.indigo450} fontWeight={"600"}>
                            {row.rank}
                        </C3Text>
                    );
                }
            },
        },
        {
            key: "shopName",
            label: Translate("store.shopName"),
            textAlign: "start",
            whiteSpace: "normal",
            minWidth: "328px",
            render: (row) => (
                <Row
                    minWidth={"328px"}
                    onClick={() => {
                        navigation(`/shops/${row.shopCode}`);
                    }}
                    cursor={"pointer"}
                >
                    <CustomNetworkImage
                        src={row.thumbnail}
                        width={"96px"}
                        height={"54px"}
                        borderRadius={"12px"}
                        cursor={"pointer"}
                    />
                    <SizedBox width={"10px"} cursor={"pointer"} />
                    <Column alignItem={"flex-start"} justifyContent={"flex-start"} flex={"1"} cursor={"pointer"}>
                        <C3Text flex={"1"} fontWeight={"500"}>
                            {row.shopName}
                        </C3Text>
                        <C3Text fontWeight={"400"} fontColor={Theme.color.gray500}>
                            {row.address}
                        </C3Text>
                    </Column>
                </Row>
            ),
        },
        {
            key: "ownerName",
            label: Translate("store.ownerName"),
        },
        {
            key: "status",
            label: Translate("common.status"),
            render: (row) => <ShopStatus status={row.status} />,
        },
        {
            key: "totalCycle",
            label: "Total Cycle",
            render: (row) => <C1Text>{row.totalCycle}</C1Text>,
        },
    ];

    return (
        <SizedBox
            border={`1px solid ${Theme.color.gray250}`}
            borderRadius={"16px"}
            width={"100%"}
            height={"373px"}
            alignItem={"flex-start"}
            justifyContent={"flex-start"}
            padding={"16px"}
            backgroundColor={"transparent"}
        >
            <C1Text>Top 10 Usage Shops</C1Text>
            <SizedBox height={"20px"} />
            <CustomTable headers={tableHeaders} data={shopList} />
        </SizedBox>
    );
}

export default TopTenUsageDashboardCard;
